module.exports = __webpack_public_path__ + "static/media/m_w_hr_0.7638cc1d.png";